module.exports={
	"Form": "RolePermissionViewManifest",
	"Scope": "RolePermission-View",
	"Descriptors":
	{
		"RolePermissionDetails.IDRolePermission":
		{
			"Name": "ID",
			"Hash": "RolePermView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "RolePermIdentity",
				"Group": "RolePermIdentity"
			}
		},
		"RolePermissionDetails.GUIDRolePermission":
		{
			"Name": "GUID",
			"Hash": "RolePermView-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "RolePermIdentity",
				"Group": "RolePermIdentity"
			}
		},
		"RolePermissionDetails.Hash":
		{
			"Name": "Permission Hash",
			"Hash": "RolePermView-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "RolePermIdentity",
				"Group": "RolePermIdentity"
			}
		},
		"RolePermissionDetails.IDRole":
		{
			"Name": "Role ID",
			"Hash": "RolePermView-IDRole",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "RolePermConfig",
				"Group": "RolePermConfig"
			}
		},
		"RolePermissionDetails.Allowed":
		{
			"Name": "Allowed",
			"Hash": "RolePermView-Allowed",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "2",
				"Width": 2,
				"Section": "RolePermConfig",
				"Group": "RolePermConfig"
			}
		},
		"RolePermissionDetails.Context":
		{
			"Name": "Context",
			"Hash": "RolePermView-Context",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "RolePermConfig",
				"Group": "RolePermConfig"
			}
		},
		"RolePermissionDetails.IDContext":
		{
			"Name": "Context ID",
			"Hash": "RolePermView-IDContext",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "RolePermConfig",
				"Group": "RolePermConfig"
			}
		},
		"RolePermissionDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "RolePermView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 6,
				"Section": "RolePermAudit",
				"Group": "RolePermAudit"
			}
		},
		"RolePermissionDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "RolePermView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 6,
				"Section": "RolePermAudit",
				"Group": "RolePermAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "RolePermIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "RolePermIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Permission Configuration",
			"Hash": "RolePermConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Permission Configuration",
					"Hash": "RolePermConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "RolePermAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "RolePermAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
